<template>
  <div class="success">
    <img src="../../static/images/credit.svg" alt="Credit Alloted Image" class="success__image" />
    <h1 class="success__text--title">Congratulations !!!</h1>
    <p class="success__text--approve-message">you have been approved a credit limit of</p>
    <h2 class="success__text--approve-amount">{{ signupStatus.creditLimit | formatCurrency }}</h2>
    <template v-if="signupStatus.kycRequired">
      <p class="success__text--message">
        Please complete your KYC and link your bank account with ePayLater
        before using this credit limit.
        <br />Linking your bank account will ensure hassle-free repayments.
      </p>
      <p class="success__text--list-title">Please ensure that you have the following-</p>
      <ul class="success__text--list-items">
        <li>A valid aadhar number or VID</li>
        <li>Access to phone number to fetch OTP send by Aadhar</li>
        <li>Bank account details or debit card details</li>
      </ul>
      <div class="success__action-row">
        <router-link :to="{ name: 'KYC Step 1' }" class="no-underline">
          <ActionButton title="Let's Begin" />
        </router-link>
        <router-link :to="{ name: 'Home' }" class="no-underline">
          <ActionButton :className="'action-button--alternate'" title="Skip For Now" />
        </router-link>
      </div>
    </template>
    <template v-else-if="signupStatus.emandateRequired">
      <p class="success__text--message">
        Please link your bank account with ePayLater before using this credit
        limit.
        <br />Linking your bank account will ensure hassle-free repayments.
      </p>
      <p
        class="success__text--list-title"
      >Please ensure that you have the bank account/debit card details with you</p>
      <div class="success__action-row">
        <router-link :to="{ name: 'eMandate' }" class="no-underline">
          <ActionButton title="Let's Begin" />
        </router-link>
        <router-link :to="{ name: 'Home' }" class="no-underline">
          <ActionButton :className="'action-button--alternate'" title="Skip For Now" />
        </router-link>
      </div>
    </template>
    <template v-else>
      <router-link class="no-underline" :to="{ name: 'Home' }">
        <ActionButton title="Go to Dashboard" />
      </router-link>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";

export default {
  name: "Signup-Success",
  data() {
    return {};
  },
  components: { ActionButton },
  computed: {
    ...mapGetters(["signupStatus"])
  },
  mounted() {
    this.$store.dispatch("getUser");
    this.$store.dispatch("signup_status");
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "CONGRATULATIONS_FINAL"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SIGNUP_COMPLETED",
      propertyName: "CREDIT_LIMIT",
      propertyValue: this.signupStatus.creditLimit
    });
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.success {
  display: grid;
  justify-items: center;
  padding: 2rem 0;
  &__image {
    margin-bottom: 2.5rem;
  }
  &__text {
    &--title {
      font-size: 2.6rem;
      color: var(--gray-2);
      margin: 0;
      margin-bottom: 2rem;
      @media only screen and (min-width: 640px) {
        font-size: 3.5rem;
      }
    }
    &--approve-message {
      font-size: 1.6rem;
      line-height: 3.11;
      text-align: center;
      color: var(--gray-2);
      margin: 0;
      @media only screen and (min-width: 640px) {
        font-size: 1.8rem;
      }
    }
    &--approve-amount {
      font-size: 3rem;
      margin: 0;
      margin-bottom: 3.5rem;
      color: var(--gray-2);
      @media only screen and (min-width: 640px) {
        font-size: 5rem;
      }
    }
    &--message {
      font-size: 1.6rem;
      color: var(--gray-6);
      &--center {
        text-align: center;
      }
    }
    &--list-title {
      font-size: 1.4rem;
      color: var(--gray-6);
      text-align: center;
    }
    &--list-items {
      font-size: 1.4rem;
      font-weight: 300;
      color: var(--gray-2);
    }
  }
  &__action-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    min-width: 30rem;
    margin-bottom: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignupSuccess.vue